export const MemberType = {
    USER: 'user',
    SERVICE_ACCOUNT: 'serviceAccount',
    GUEST_LINK: 'guestLink',
};
